export const redirectToUrl = data => {
  if (data && data.url) {
    window.location.href = data.url;
  }
};

export default redirectToUrl;
